import { Link } from "react-router-dom";

type BreadcrumbItem = {
  label: string;
  to?: string;
};

type BreadcrumbProps = {
  items: BreadcrumbItem[];
};

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-1.5 text-[11px] md:text-xs">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <span key={`${item.label}-${index}`} className="inline-flex items-center gap-1.5">
            {item.to && !isLast ? (
              <Link
                to={item.to}
                className="focus-ring inline-flex items-center gap-1 rounded text-foreground-500 transition-colors hover:text-secondary-700"
              >
                {index === 0 ? <i className="ri-home-5-line text-xs" aria-hidden="true" /> : null}
                {item.label}
              </Link>
            ) : (
              <span className={isLast ? "font-medium text-foreground-800" : "text-foreground-500"}>
                {item.label}
              </span>
            )}
            {!isLast ? (
              <i className="ri-arrow-right-s-line text-xs text-background-400" aria-hidden="true" />
            ) : null}
          </span>
        );
      })}
    </nav>
  );
}